export default "__VITE_ASSET__fceef6b1__"